import * as OM from '@/model';
import * as VM from '@/viewmodel';
import * as Enum from '@/enum';
import { CommonServices } from '@/services/CommonServices';
import { BaseUserClient } from './Services';
import router from '@/router';

class _PushServices {
    
    register(onTokenRefreshCb: (fcmToken) => void){
        return new Promise<void>((resolve, reject) => {

            FirebasePlugin.hasPermission(hasIt => {
                if(hasIt){
                    onPermissionOk()
                    .then(x => {
                        resolve();
                    })    
                } else {
                    FirebasePlugin.grantPermission((hasPermission) => {

                        console.log(
                            "Notifications permission was " + (hasPermission ? "granted" : "denied")
                        );
                        if(!hasPermission){
                            return;
                        }
                        
                        onPermissionOk()
                        .then(x => {
                            resolve();
                        })

                    });
                }
            })

        })

        function onPermissionOk(){
            return new Promise<void>((resolve, reject) => {
                FirebasePlugin.onTokenRefresh((fcmToken) => {
                    onTokenRefreshCb(fcmToken);
                    resolve(fcmToken);
                });
                
                FirebasePlugin.onMessageReceived(function (notification) {
                    console.log("notification received", notification);
                    if (notification.tap) {
                        if(notification.routeTo){
                            router.push(notification.routeTo);
                        }
                    }
                }, function (error) {
                    console.error("Error receiving push", error);
                });
            })
        }
    }

    unregister(){
        FirebasePlugin.setAutoInitEnabled(false, function () {
            console.log("Auto init has been disabled ");
            FirebasePlugin.unregister();
        });
    }

    subscribeToTopic(topic: string){
        return new Promise((resolve, reject) => {
            FirebasePlugin.subscribe(topic, function () {
                resolve(null)
            }, function (error) {
                reject(error)
            });
        })
    }

    unsubscribeToTopic(topic: string){
        return new Promise((resolve, reject) => {
            FirebasePlugin.unsubscribe(topic, function () {
                resolve(null)
            }, function (error) {
                reject(error)
            });
        })
    }

}

export let PushServices = new _PushServices();

